export default "__VITE_ASSET__T$GYJjXU__"